import { styled } from "@mui/material";
import { keyframes } from "@emotion/react";
import myImage from "../../images/my-img.png";
import revealImage from "../../images/DP2.jpeg";

import { FaLinkedin, FaGithub } from "react-icons/fa6";
import { FaFileContract } from "react-icons/fa";
import { SiGmail,SiLeetcode  } from "react-icons/si";
import { GrArticle } from "react-icons/gr";

export const HeroWrapper = styled("section")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  height: "100vh",
  paddingTop: "5rem",
  backgroundColor: "transparent",
  position: "relative",
  "@media (max-width: 900px)": {
    height: "auto",
    padding: "11rem 0",
  },
}));

export const SectionContainer = styled("div")(() => ({
  maxWidth: "107rem",
  margin: "0 auto",
  padding: "0 4rem",
  "@media (max-width: 460px)": {
    gridTemplateColumns: "1fr",
    padding: "0 1.7rem",
  },
}));

export const SectionContent = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "58rem",
  gap: "10rem",
  position: "relative",
  "@media (max-width: 900px)": {
    flexDirection: "column",
    textAlign: "center",
    height: "auto",
    gap: "3rem",
  },
  "@media (min-width: 1600px)": {
    marginTop: "6rem",
  },
  "@media (min-width: 1900px)": {
    marginTop: "10rem",
  },
}));

export const HeroMain = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10rem",
  position: "relative",
  "@media (max-width: 900px)": {
    flexDirection: "column-reverse",
    textAlign: "center",
    height: "auto",
    gap: "3rem",
  },
}));

export const HeroText = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  maxWidth: "50rem",
  position: "relative",
  opacity: 0,
  transform: "translateX(-100%)",
  transition: "transform 1s ease-in-out, opacity 1s ease-in-out",
}));

export const HeroTextH1 = styled("h1")(() => ({
  fontSize: "5.5rem",
  lineHeight: 1.2,
  color: "#faf0f0",
  marginBottom: "5rem",
  marginTop: "2rem",
  "@media (max-width: 500px)": {
    fontSize: "3.20rem",
    marginBottom: "5rem",
  },
}));

export const HeroTextP = styled("p")(() => ({
  fontSize: "1.8rem",
  fontWeight: 500,
  color: "#828782",
  fontFamily: "Mulish, sans-serif",
  lineHeight: 1.6,
  "@media (max-width: 1100px)": {
    marginBottom: "5rem",
    fontSize: "1.5rem",
  },
  "@media (max-width: 900px)": {
    marginBottom: "5rem",
  },
}));

export const HeroTextSpan = styled("span")(() => ({
  display: "flex",
  gap: "1.3rem",
  margin: "2.5rem 0",
  cursor: "pointer",
  "@media (max-width: 900px)": {
    justifyContent: "center",
    marginTop: "-2rem",
    marginBottom: "4rem",
    gap: "1.6rem",
  },
}));

export const HeroTextSpanA = styled("a")(() => ({
  fontSize: "3rem",
  color: "#828782",
}));

export const IconLinkden = styled(FaLinkedin)(()=>({
  transition: "transform 0.3s ease-in-out",
  color:"#4285F4",

  ":hover": {
    transform: "scale(1.2)",
  },
}));
export const IconGithub = styled(FaGithub)(()=>({
  transition: "transform 0.3s ease-in-out",
  color:"#DB4437",

  ":hover": {
    transform: "scale(1.2)",
  },
}));
export const IconMail = styled(SiGmail)(()=>({
  transition: "transform 0.3s ease-in-out",
  color:"#F4B400",

  ":hover": {
    transform: "scale(1.2)",
  },
}));
export const IconArticle = styled(GrArticle)(()=>({
  transition: "transform 0.3s ease-in-out",
  color:"#4285F4",

  ":hover": {
    transform: "scale(1.2)",
  },
}));
export const IconFile = styled(FaFileContract)(()=>({
  transition: "transform 0.3s ease-in-out",
  color:"#0F9D58",

  ":hover": {
    transform: "scale(1.2)",
  },
}));
export const IconCode = styled(SiLeetcode)(()=>({
  transition: "transform 0.3s ease-in-out",
  color:"#DB4437",

  ":hover": {
    transform: "scale(1.2)",
  },
}));

export const HeroTextSpanImg = styled("img")(() => ({
  position: "absolute",
  width: "5rem",
  height: "5rem",
  top: "14rem",
  right: "20rem",
  "@media (max-width: 900px)": {
    right: "21rem",
    top: "19rem"
  },
  "@media (max-width: 500px)": {
    top: "11.5rem",
    right: "17.5rem",
    width: "4.5rem",
    height: "4.5rem",
  },
  "@media (max-width: 400px)": {
    right: "15rem",
    top: "12rem",
  },
  "@media (max-width: 380px)": {
    right: "15rem",
    top: "10rem"
  },
  "@media (max-width: 370px)": {
    right: "14rem",
    top: "12.5rem",
  },
}));

const morphAnimation = keyframes({
  "0%": {
    borderRadius: "60% 40% 30% 70%/60% 30% 70% 40%",
  },
  "50%": {
    borderRadius: "30% 60% 70% 40%/50% 60% 30% 60%",
  },
  "100%": {
    borderRadius: "60% 40% 30% 70%/60% 30% 70% 40%",
  },
});

const moveUpAnimation = keyframes`
  0% {
    transform: translateY(100%);
  }
  50% {
    transform: translateY(-10%);
  }
  100% {
    transform: translateY(0%);
  }
  animation-fill-mode: forwards; 
`;

export const HeroImage = styled("div")(() => ({
  backgroundImage: `url(${myImage})`,
  width: "35rem",
  height: "35rem",
  backgroundSize: "cover",
  backgroundPosition: "50%",
  backgroundRepeat: "no-repeat",
  border: "3px solid white",
  animation: `${morphAnimation} 8s ease-in-out infinite, ${moveUpAnimation} 1.5s ease-in-out forwards`,
  borderRadius: "60% 40% 30% 70%/60% 30% 70% 40%",
  position: "relative",
  overflow: "hidden",
  transition: "all 1s ease-in-out",
  transform: "translateY(100%)",
  animationFillMode: "forwards",
  "&:hover": {
    cursor: "none",
  },
  "@media (max-width: 500px)": {
    width: "28rem",
    height: "28rem",
  },
}));

// Continuously shifting, deliberately lopsided base silhouette. The extreme,
// asymmetric radii give an off-round teardrop/kidney form; the SVG turbulence
// filter (below) then chews organic pseudopods and dents into that edge so it
// reads as a living amoeba rather than a wobbling circle.
const blobMorph = keyframes({
  "0%": { borderRadius: "72% 28% 61% 39%/44% 68% 32% 56%" },
  "20%": { borderRadius: "33% 67% 38% 62%/58% 33% 67% 42%" },
  "40%": { borderRadius: "64% 36% 27% 73%/71% 55% 45% 29%" },
  "60%": { borderRadius: "29% 71% 66% 34%/35% 41% 59% 65%" },
  "80%": { borderRadius: "58% 42% 71% 29%/62% 30% 70% 38%" },
  "100%": { borderRadius: "72% 28% 61% 39%/44% 68% 32% 56%" },
});

export const RevealBlob = styled("div")(() => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "17rem",
  height: "17rem",
  backgroundImage: `url(${revealImage})`,
  backgroundRepeat: "no-repeat",
  pointerEvents: "none",
  opacity: 0,
  // Centre the blob on the cursor coords that JS writes to left/top.
  translate: "-50% -50%",
  scale: "0.55",
  willChange: "left, top, border-radius, opacity, scale",
  borderRadius: "72% 28% 61% 39%/44% 68% 32% 56%",
  // The turbulence filter displaces the rounded edge into organic amoeba
  // lobes and indentations; it animates on its own via SMIL (see Hero.jsx).
  filter: "url(#amoeba-edge)",
  transition:
    "opacity 0.45s ease, scale 0.5s cubic-bezier(0.22, 1, 0.36, 1)",
  animation: `${blobMorph} 7s ease-in-out infinite`,
  "&.is-active": {
    opacity: 1,
    scale: "1",
  },
  "@media (max-width: 500px)": {
    width: "13rem",
    height: "13rem",
  },
}));

export const Skills = styled("div")(() => ({
  display: "flex",
  fontSize: "1.7rem",
  color: "#767676",
  alignItems: "center",
  position: "absolute",
  bottom: 0,
  left: 0,
  opacity: 0,
  transform: "translateX(-100%)",
  transition: "transform 1s ease-in-out, opacity 1s ease-in-out",
  "@media (max-width: 900px)": {
    position: "initial",
    flexDirection: "column",
  },
}));

export const SkillsP = styled("p")(() => ({
  marginRight: "2rem",
  paddingRight: "1rem",
  borderRight: "2px solid #828782",
  fontFamily: ["Mulish", "sans-serif"],
  fontWeight: 600,
  color: "#828782",
  "@media (max-width: 900px)": {
    marginRight: 0,
    marginBottom: "3rem",
    borderBottom: "2px solid rgba(45, 46, 50, 0.5)",
    borderRight: "none",
    paddingRight: 0,
    paddingBottom: "1rem",
  },
}));

export const SkillsUl = styled("ul")(() => ({
  listStyle: "none",
  display: "flex",
  flexWrap: "wrap",
  gap: "1.6rem",
  "@media (max-width: 900px)": {
    justifyContent: "center",
  },
}));

const techFloat = keyframes({
  "0%, 100%": { transform: "translateY(0)" },
  "50%": { transform: "translateY(-8px)" },
});

export const SkillsUlLi = styled("li")(() => ({
  width: "5.4rem",
  height: "5.4rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  backgroundColor: "white",
  cursor: "pointer",
  animation: `${techFloat} 5s ease-in-out infinite`,
  transition: "box-shadow 0.3s ease",
  "& svg": {
    transition: "transform 0.6s ease",
  },
  "&:hover": {
    boxShadow: "0 0 22px var(--glow, #ffffff)",
  },
  "&:hover svg": {
    transform: "scale(1.22) rotate(360deg)",
  },
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
  },
}));

export const SkillsUlLiImg = styled("img")(() => ({
  width: "3.4rem",
  height: "3.4rem",
}));
